import React from 'react';

interface AppLoadingScreenProps {
  /** Render inline (no full-screen background) for use inside layouts */
  inline?: boolean;
}

/**
 * Unified loading spinner used throughout the app.
 * Full-screen variant for app initialization; inline variant for content areas.
 */
const AppLoadingScreen: React.FC<AppLoadingScreenProps> = ({ inline = false }) => {
  if (inline) {
    return (
      <div className="flex items-center justify-center h-full min-h-[200px]">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-50">
      <Spinner />
    </div>
  );
};

const Spinner: React.FC = () => (
  <div className="relative">
    <div className="w-10 h-10 rounded-full border-4 border-ink-200" />
    <div className="absolute top-0 left-0 w-10 h-10 rounded-full border-4 border-transparent border-t-accent-500 animate-spin" />
  </div>
);

export default AppLoadingScreen;
